import React from 'react'
import { connect } from 'react-redux'
import styles from './Body.module.css';
import { PatientHomePeerReviewMsg } from 'PatientCareCenter/Home/PeerReviews'
import { sortDateTimeMDYYYYHMMMSSAA } from '_helpers';

class PatientHomePeerReviewBody extends React.Component {

    render() {
        if (this.props.visible) {
            if (Object.keys(this.props.msgs).length === 0) {
                return (
                    <div className={styles.no_msgs}><i>No messages</i></div>
                )
            } else {
                return (
                    <div className={styles.body_wrapper}>
                        <div className={styles.title}>{this.props.title}</div>
                        {Object.keys(this.props.msgs)
                            .map(id => {
                                const msg = this.props.msgs[id];
                                return (
                                    <PatientHomePeerReviewMsg key={msg.id} id={msg.id} />
                                )
                            })
                        }

                    </div >
                );
            }
        } else {
            return (
                <div></div>
            );
        }
    }
}

function mapStateToProps(state, ownprops) {
    return {
        visible: state.ui.peerReviews[ownprops.id].visible,
        title: state.entities.peerReviews[ownprops.id].title,
        msgs: Object.keys(state.entities.peerReviewMsgs)
            .filter(key => { return state.entities.peerReviewMsgs[key].peerReview === ownprops.id })
            .sort((a, b) => { return sortDateTimeMDYYYYHMMMSSAA(state.entities.peerReviewMsgs[a].dateTime, state.entities.peerReviewMsgs[b].dateTime, 'desc') })
            .map(key => state.entities.peerReviewMsgs[key])
    };
}

const connectedPatientHomePeerReviewBody = connect(mapStateToProps)(PatientHomePeerReviewBody);
export { connectedPatientHomePeerReviewBody as PatientHomePeerReviewBody };

